export default __webpack_public_path__ + "static/media/galvanic-zinc-plating-icon.60321586.svg";